// extracted by mini-css-extract-plugin
module.exports = {"affirm_logo":"affirmPriceWidget_affirm_logo__K4dY8","link_text":"affirmPriceWidget_link_text___H7kE","affirm_ala":"affirmPriceWidget_affirm_ala__Tubom"};